import { Component } from '@angular/core'

@Component({
  selector: 'disclosures',
  templateUrl: './disclosures.component.html',
  styleUrls: ['./disclosures.component.scss'],
})
export class DisclosuresComponent {}
